import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import HeroDiagonalAccent from './HeroDiagonalAccent';
import SectionSurface from '../shared/SectionSurface';
import PartnerBadges from '../solutions/data-engineering/PartnerBadges';
import LogoSlideshow from './LogoSlideshow';
import { HERO_PRODUCTION, HERO_CARDS } from '../../../content/enterpriseMessaging';

const HERO_CARD_BADGES = ['badge-brand', 'badge-navy', 'badge-accent', 'badge-enterprise'];

export default function HeroPrimary() {
  return (
    <SectionSurface
      variant="wash"
      as="section"
      decor="none"
      underNav
      bleed="both"
      accentEl={<HeroDiagonalAccent />}
    >
      <div className="container-x pb-10" data-hero-primary>
        <div className="relative z-10 mx-auto flex w-full min-w-0 max-w-5xl flex-col items-center px-4 text-center sm:px-6">
          <p className="eyebrow w-full min-w-0">{HERO_PRODUCTION.eyebrow}</p>
          <h1 data-brand-headline className="mt-3 w-full min-w-0 text-balance break-words font-display text-[1.85rem] font-semibold leading-[1.12] tracking-tight text-ink-900 sm:text-5xl lg:text-[3.5rem]">
            {HERO_PRODUCTION.titleLead}
            <span className="text-brand-600">{HERO_PRODUCTION.titleHighlight}</span>
          </h1>
          <p className="mx-auto mt-5 w-full min-w-0 max-w-4xl text-pretty break-words text-base leading-relaxed text-ink-600 sm:text-xl">
            {HERO_PRODUCTION.subtitle}
          </p>

          <div className="mt-8 flex w-full min-w-0 flex-col items-stretch justify-center gap-3 sm:flex-row sm:flex-wrap sm:items-center">
            <a href={HERO_PRODUCTION.primaryCta.href} className="btn-primary btn-lg">
              {HERO_PRODUCTION.primaryCta.label}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
            </a>
            <a href={HERO_PRODUCTION.secondaryCta.href} className="btn-secondary btn-lg">
              {HERO_PRODUCTION.secondaryCta.label}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
            </a>
            <a
              href="/semantic-hr"
              className="inline-flex min-h-[44px] items-center justify-center text-sm font-medium text-ink-600 underline-offset-4 hover:text-brand-600 hover:underline"
            >
              Explore Semantic HR <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>

        <div className="relative z-10 mx-auto mt-6 grid max-w-6xl grid-cols-1 items-stretch gap-6 px-4 pt-4 sm:px-6 md:grid-cols-2 lg:px-8">
          {HERO_CARDS.map((card, index) => (
            <a
              key={card.title}
              href={card.href}
              className="card-hover relative flex h-full min-h-[200px] flex-col rounded-xl border border-ink-200/90 bg-white px-6 pb-6 pt-8 text-left shadow-sm"
            >
              <span
                className={`${HERO_CARD_BADGES[index] || 'badge-brand'} absolute -top-3 left-4 z-10 max-w-[calc(100%-2rem)] whitespace-normal break-words sm:left-6 sm:max-w-[calc(100%-3rem)]`}
              >
                {card.title}
              </span>
              <p className="flex-1 text-sm leading-6 text-ink-600">{card.body}</p>
              <span className="mt-auto inline-flex justify-end pt-4 text-sm font-medium text-brand-700">
                Learn more <span className="ml-1" aria-hidden="true">→</span>
              </span>
            </a>
          ))}
        </div>
      </div>

      <PartnerBadges />
      <LogoSlideshow />
    </SectionSurface>
  );
}
